var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * This is a simple function that exposes the same api as the useFetchEffect
 */
export function fetchHelper(request, options, signal) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var fetchOptions, url, method, body, contentType, rawResponse, newHeaders, response, responseBody, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.resolve(typeof options === 'function' ? options() : options)];
                case 1:
                    fetchOptions = _b.sent();
                    body = undefined;
                    contentType = undefined;
                    rawResponse = false;
                    // If you just pass a string, we assume it's a POST
                    if (typeof request === 'string') {
                        url = request;
                        method = 'POST';
                    }
                    else {
                        url = request.url;
                        method = request.method || 'POST';
                        if (typeof request.rawResponse !== 'undefined') {
                            rawResponse = request.rawResponse;
                        }
                        if ('json' in request) {
                            // We use this to provide type safety
                            body = JSON.stringify(request.json);
                            contentType = 'application/json';
                        }
                        else if ('body' in request && request.body !== undefined) {
                            body = request.body;
                            contentType = request.contentType;
                        }
                    }
                    if (signal) {
                        fetchOptions.signal = signal;
                    }
                    if (typeof body !== undefined) {
                        fetchOptions.body = body;
                        if (contentType) {
                            newHeaders = new Headers(fetchOptions.headers);
                            newHeaders.set('Content-Type', contentType);
                            fetchOptions.headers = newHeaders;
                        }
                    }
                    if (method) {
                        fetchOptions.method = method;
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, fetch(url, fetchOptions)];
                case 3:
                    response = _b.sent();
                    if (response.status === 204) {
                        // No Content, we have no body
                        return [2 /*return*/, { response: null }];
                    }
                    if (rawResponse) {
                        return [2 /*return*/, { raw: response }];
                    }
                    return [4 /*yield*/, response.json()];
                case 4:
                    responseBody = _b.sent();
                    /**
                     * We use responseBody as TResponse or as TError because we should trust the developer and
                     * the API to provide matching types. This makes it possible to have a runtime error but
                     * we don't have a better way to handle this.
                     */
                    if (response.ok) {
                        return [2 /*return*/, { response: responseBody }];
                    }
                    return [2 /*return*/, { error: responseBody }];
                case 5:
                    e_1 = _b.sent();
                    // since there is no UI response needed for these cases
                    // we consider aborted as finished with null response
                    // if we return {error} the UI will display it
                    // and then we will need to verify if it is an AbortError or Generic Error
                    if ((_a = fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.signal) === null || _a === void 0 ? void 0 : _a.aborted) {
                        return [2 /*return*/, { response: null }];
                    }
                    // TODO: Better error handling. Network error? Json error?
                    console.error(e_1);
                    // JSON Parsing error, we fallback to generic error message
                    return [2 /*return*/, { error: { message: 'Internal server error' } }];
                case 6: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=fetchHelper.js.map